import axiosInstance from "@/services/http/axios-instance";

export class OrderApi {
  getOrders() {
    return axiosInstance.get("/order");
  }

  createOrder(clientId, widgetType) {
    return axiosInstance.post("/order/create", {
      client_id: clientId,
      widget_type: widgetType,
    });
  }

  getOrderStatus(orderId) {
    return axiosInstance.get(`/order/${orderId}/status`);
  }

  loadReceipt(orderItemId, receiptType) {
    return axiosInstance.get(`/order/item/${orderItemId}/receipt`, {
      params: {
        receipt_type: receiptType,
      },
      responseType: "blob",
    });
  }

  loadOrderPDFReceipt(orderId, receiptType) {
    return axiosInstance.get(`/order/${orderId}/receipt`, {
      params: {
        receipt_type: receiptType,
      },
      responseType: "blob",
    });
  }

  loadOrderReceipt(orderId) {
    return axiosInstance.get(`/order/${orderId}/receipts`, {
      responseType: "blob",
    });
  }

  loadOrder(orderId, updateStatus = 0) {
    return axiosInstance.get(`/order/${orderId}`, {
      params: {
        update_status: updateStatus,
      },
    });
  }

  updateOrderWidgetLink(orderId) {
    return axiosInstance.get(`/order/${orderId}/update/pay-link`);
  }

  loadOrderItemRepeatData(orderItemId) {
    return axiosInstance.get(`/order/item/${orderItemId}/repeat`);
  }
}
